function normalizeText(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.replace(/\s+/g, ' ').trim();
}

function stripHtml(value) {
  return normalizeText(String(value || '').replace(/<[^>]*>/g, ' '));
}

export function slugifyContentSegment(value) {
  const normalized = normalizeText(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return normalized || 'content';
}

export function resolvePublicContentKind(content = {}) {
  const explicitType = normalizeText(content?.post_type).toLowerCase();
  if (explicitType === 'article' || explicitType === 'post') {
    return explicitType;
  }

  return normalizeText(content?.post_container?.post_title || content?.title) ? 'article' : 'post';
}

export function resolvePublicContentId(content = {}) {
  return content?._id || content?.id || content?.post_id || content?.article_id || null;
}

export function buildPublicContentPath(content = {}, explicitKind = null) {
  const kind = explicitKind || resolvePublicContentKind(content);
  const id = resolvePublicContentId(content);
  const title = normalizeText(content?.post_container?.post_title || content?.title);
  const description = normalizeText(content?.post_container?.post_description || content?.description);
  const ownerUsername = normalizeText(
    content?.gallery?.user_username
    || content?.artist?.user_username
    || content?.collector?.user_username
    || content?.creator_username
  );
  const slugSource = title || description || ownerUsername || kind;
  const slug = slugifyContentSegment(stripHtml(slugSource));

  if (!id) {
    return `/${kind}/${slug}`;
  }

  return `/${kind}/${slug}/${id}`;
}

export function resolveLegacyContentPath(content = {}, explicitKind = null) {
  const kind = explicitKind || resolvePublicContentKind(content);
  const id = resolvePublicContentId(content);
  return id ? `/${kind}/${id}` : `/${kind}`;
}
